import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}><path fill="none" stroke="currentColor" strokeWidth="2" d="M0 7h14" /></svg>);